import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, UIConstants } from '@streem/ui-react';
import { ToolbarCallDetails } from './tools/toolbar_call_details';
import { LocalAudioMuteButton } from './tools/local_audio_mute_button';
import { useCompanySettings } from '../../../context/company_settings';
import { EndCallButton } from './tools/end_call_button';
import { GuideButton } from './tools/guide_button';
import { ToggleCameraButton } from './tools/toggle_camera_button';
import { useRoomSession } from '../../../context/room_session';
import { Timer } from './tools/timer';
import { useObservable } from '../../../hooks/rxjs';
import { LocalAudioInputSelect } from './tools/local_audio_input_select';
import { LocalVideoInputSelect } from './tools/local_video_input_select';
import { isOnSiteRoomSession } from '@streem/sdk-core';
export { CenterToolBar } from './center_toolbar';
export const RightToolBar = ({ handleGuideToggle, isTrayOpen, remoteIsARCapable, showGuideUI, }) => {
    const settings = useCompanySettings();
    const roomSession = useRoomSession();
    const [callStartTime] = useObservable(roomSession.bookmarks.callStartTime);
    const showGuideButton = !!settings?.arEnabled && !!remoteIsARCapable;
    const showRemoteDetails = !isOnSiteRoomSession(roomSession) && !roomSession.callSettings.faceToFaceModeEnabled;
    return (_jsx(RightToolbarWrapper, { children: _jsxs(RightToolbarToolsWrapper, { children: [showRemoteDetails && (_jsx(ToolbarCallDetails, { isTrayOpen: isTrayOpen, roundLeftEdgeYn: true, roundRightEdgeYn: false })), showGuideButton && (_jsx(GuideButton, { handleGuideToggle: handleGuideToggle, showGuideUI: showGuideUI, roundLeftEdgeYn: !showRemoteDetails, roundRightEdgeYn: false })), _jsx(ToggleCameraButton, { roundLeftEdgeYn: !showGuideButton && !showRemoteDetails, roundRightEdgeYn: false }), _jsx(LocalVideoInputSelect, {}), _jsx(LocalAudioMuteButton, { roundLeftEdgeYn: false, roundRightEdgeYn: false }), _jsx(LocalAudioInputSelect, { isTrayOpen: isTrayOpen }), _jsx(Timer, { callStartTime: callStartTime?.clientCreatedAt }), _jsx(Divider, {}), _jsx(EndCallButton, {})] }) }));
};
const Divider = styled.span(({ theme }) => ({
    height: `${UIConstants.BOTTOM_ROW_ELEMENT_HEIGHT_REM}rem`,
    width: '1px',
    backgroundColor: theme.colors.grey10,
    margin: '0 .75rem',
}));
const RightToolbarToolsWrapper = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.white,
    borderTopLeftRadius: UIConstants.ROUNDED_BUTTON_BORDER_RADIUS,
    borderBottomLeftRadius: UIConstants.ROUNDED_BUTTON_BORDER_RADIUS,
    alignSelf: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0',
    marginLeft: theme.spacing.s,
}));
const RightToolbarWrapper = styled.div(() => ({
    display: 'inline-flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginLeft: 'auto',
}));
//# sourceMappingURL=index.js.map